import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Results } from '@local/client-contracts';
import { CreateGoLinkItem } from '../../models/results-types';

@Component({
  selector: 'create-go-link-item',
  templateUrl: './create-go-link-item.component.html',
  styleUrls: ['./create-go-link-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateGoLinkItemComponent {
  @Input() model: CreateGoLinkItem;
  @Input() set selected(value: boolean) {
    this._selected = value;
  }
  @Input() index: number;
  @Input() isLauncher: boolean;
  @Output() invoke = new EventEmitter<CreateGoLinkItem>();

  get selected() {
    return this._selected;
  }

  get title(): Results.Title {
    return {
      text: this.model?.title,
    };
  }

  get subtitle(): Results.Subtitle {
    this.model.url = this.model.url.trim();
    return {
      text: `"${this.model.url}"`,
    };
  }
  private _selected: boolean;

  async onInvoke(): Promise<void> {
    this.invoke.emit(this.model);
  }
}
